/* global $ */

import { Controller } from 'stimulus';
import debounce from '../helpers/debounce';

const checkIcon = `
  <svg class="icon icon-check" aria-hidden="true"><use xlink:href="#icon-check"></use></svg>
`;

const makeRequest = query => $.ajax({
  url: '/api/dealers',
  data: {
    query,
  },
});

class DealerLocator extends Controller {
  connect() {
    this.value = parseInt(this.inputTarget.value, 10);
    this.debouncedSearch = debounce(this.search.bind(this), 200);

    const searchValue = this.searchInputTarget.value;

    if (searchValue) {
      this.search(searchValue);
    }
  }

  onSearchKeyup(e) {
    this.debouncedSearch(e.target.value);
  }

  onSelect(e) {
    const button = e.target.closest('button');
    const id = button.getAttribute('data-id');
    const name = button.getAttribute('data-name');

    // Deselect all options in the dropdown visually
    this.deselectAll();

    // Store the selected location in the hidden input field
    this.value = parseInt(id, 10);
    this.inputTarget.value = this.value;

    this.toggleTextTarget.textContent = name;
    button.classList.add('is-selected');

    this.closeCollapse();

    this.removeError();
  }

  deselectAll() {
    this.resultTargets.forEach((target) => {
      target.classList.remove('is-selected');
    });
  }

  search(query) {
    makeRequest(query)
      .then(this.renderResults.bind(this))
      .catch(this.renderEmpty.bind(this));
  }

  closeCollapse() {
    const collapsible = this.element.querySelector('.collapse');

    if (collapsible) {
      $(collapsible).collapse('hide');
    }
  }

  validate() {
    const isVisible = !!this.element.offsetParent;

    this.removeError();

    if (isVisible && !this.value) {
      const errorElement = document.createElement('div');
      errorElement.textContent = 'Dit veld is verplicht';
      errorElement.className = 'porta-error-message';

      this.element.appendChild(errorElement);

      return false;
    }

    return true;
  }

  removeError() {
    const existingError = this.element.querySelector('.porta-error-message');

    if (existingError) {
      this.element.removeChild(existingError);
    }
  }

  renderResults(locations) {
    if (locations.length <= 0) {
      this.renderEmpty();
      return;
    }

    const items = [];

    locations.forEach((location) => {
      items.push(this.renderResult(location));
    });

    this.resultsTarget.innerHTML = items.join('');
  }

  renderResult(location) {
    const isSelected = this.value === parseInt(location.id, 10);

    return `
      <button 
        class="select-box__result is-multi-line btn--reset ${isSelected ? 'is-selected' : ''}" 
        type="button" 
        data-action="click->dealer-locator#onSelect"
        data-id="${location.id}"
        data-target="dealer-locator.result"
        data-name="${location.title}"
      >
        ${checkIcon} ${location.title}<br>
        <small>${location.address}</small>
      </button>
    `;
  }

  renderEmpty() {
    this.resultsTarget.innerHTML = `
      <div class="pt-3 text-muted">
        Geen resultaten
      </div>
    `;
  }
}

DealerLocator.targets = [
  'results',
  'result',
  'input',
  'searchInput',
  'toggleText',
];

export default DealerLocator;
